<template>
  <div class="container">
    <div class="loading" v-if="performingRequest">
      <p>Loading...</p>
    </div>
    <div v-if="!performingRequest">
      <h1>Cereal City Science Professional Learning Registration</h1>
      <div class="training-info">
        <h3>Selected Training Sessions:</h3>
        <div v-for="training in trainingsToRegister" :key="training.index" class="sessions-list">
          <h4>{{ training.selectedTitle }}</h4>
          <p><b>Session Date<span v-if="training.selectedSessionTwo != 'Invalid date'">s</span>:</b> {{ training.selectedSessionOne }}<span v-if="training.selectedSessionTwo != 'Invalid date'">, {{ training.selectedSessionTwo }}</span><span v-if="training.selectedSessionThree != 'Invalid date'">, {{ training.selectedSessionThree }}</span><br />
          <b>Time:</b> {{ training.selectedTime }}</p>
        </div>
      </div>

      <div class="registering-container">
        <div class="form-element">
          <p><b>I am registering:</b></p>
          <label for="self">Myself</label>
          <input type="radio" id="self" value="self" v-model="registeringFor">
          <label for="other" style="margin-left: 15px;">Someone Else</label>
          <input type="radio" id="other" value="other" v-model="registeringFor">
        </div>
      </div>

      <!-- *** Registration Forms *** -->
      <reg-participant v-if="registeringFor == 'other'"></reg-participant>
      <reg-self v-if="registeringFor == 'self'"></reg-self>

    </div>
    <div>
      <p class="fine-print"><b>Training/Workshop Cancellation Policy:</b> Cancellations must be made at least 7 days prior to the start of the workshop or training. If your district ordered a teacher guide for you, it will be shipped at the district's expense. If you do not cancel, you will be charged the predetermined rate for the workshop or training.</p>
    </div>
  </div>
</template>

<script>
// const fb = require('./../firebase/firebase')
// import moment from 'moment'
import { mapState } from 'vuex'
import RegParticipant from './../components/registration/RegParticipant.vue'
import RegSelf from './../components/registration/RegSelf.vue'

export default {
  data() {
    return {
      performingRequest: false,
      registeringFor: 'self',
      district: '',
      building: '',
      purchaseOrder: '',
      acknowledgement: '',
      dateSubmitted: '',
      trainingSession: '',
      sessionDate: '',
      participantFirstName: '',
      participantLastName: '',
      participantEmail: '',
      participantPhone: '',
      hasGuide: '',
      registrantFirstName: '',
      registrantLastName: '',
      registrantEmail: '',
      registrantPhone: '',
      training: []
    }
  },
  components: {
    RegParticipant,
    RegSelf
  },
  computed: {
    ...mapState([ 'trainingsToRegister', 'regHelper' ])
  },
  methods: {
    // fetchTraining(id) {
    //   fb.cohortSessionsCollection.doc(id).get().then((doc) => {
    //     if (doc.exists) {
    //       this.training.id = doc.id,
    //       this.training.cost = doc.data().cost,
    //       this.training.program = doc.data().program,
    //       this.training.sessionOne = moment(doc.data().sessionOne).format('LL'),
    //       this.training.sessionTwo = moment(doc.data().sessionTwo).format('LL'),
    //       this.training.sessionThree = moment(doc.data().sessionThree).format('LL'),
    //       this.training.time = doc.data().time,
    //       this.training.trainingTitle = doc.data().trainingTitle
    //     } else {
    //       console.log('No such document.')
    //     }
    //   }).then(() => {
    //     console.log(this.training)
    //     this.performingRequest = false
    //   }).catch((err) => {
    //     console.log(err)
    //   })
    // }
  },
  mounted() {
    if (this.trainingsToRegister.length < 1) {
      this.$router.push('/training')
    }
    // if (this.regHelper != []) {
    //   this.registeringFor = this.regHelper[0].registeredBy
    // }
    // this.performingRequest = true
    // setTimeout(() => {
    //   this.fetchTraining(this.trainingToRegister)
    // }, 1500)
  }
}
</script>

<style lang="css" scoped>
.training-info {
  background: #f7f7f7;
  border: 2px solid #cecece;
  border-radius: 5px;
  padding: 0;
  margin: 20px auto;
  width: 60%;
  text-align: left;
  overflow: hidden;
}
.training-info p {
  text-align: left;
  margin: 5px;
}
.training-info h3 {
  padding: 10px 20px;
  color: white;
  background: #f47e20;
  margin: 0;
}
h1 {
  padding-top: 20px;
}
.registering-container {
  border: 2px solid #cecece;
  background: #f7f7f7;
  width: 60%;
  margin: 20px;
  padding: 20px;
  border-radius: 5px;
  margin-left: auto;
  margin-right: auto;
  vertical-align: top;
}
input[type="radio"], input[type="checkbox"] {
  width: auto;
}
.registering-container p {
  margin-top: 0;
  margin-bottom: 0;
}
/* .registrant-container {
  border: 1px solid #cecece;
  background: #f7f7f7;
  width: 60%;
  margin: 20px;
  padding: 30px;
  border-radius: 5px;
  margin-left: auto;
  margin-right: auto;
}
.registrant-container p {
  margin-top: 0;
  text-align: center;
}
.main-form {
  border: 1px solid #cecece;
  background: #f7f7f7;
  width: 60%;
  margin: 20px;
  padding: 30px;
  border-radius: 5px;
  margin-left: auto;
  margin-right: auto;
  vertical-align: top;
}
.form-element {
  text-align: left;
  margin-bottom: 20px;
} */
input {
  width: 100%;
  padding: 12px 20px;
  border: 1px solid #cecece;
  border-radius: 5px;
}
.sessions-list {
  margin: 0;
  border-top: 1px solid #cecece;
  background: white;
  padding: 10px 20px;
}
.form-element {
  text-align: left;
  margin: 0;
  padding: 0;
}
input {
  width: 100%;
  padding: 12px 20px;
  border: 1px solid #cecece;
  border-radius: 5px;

  margin-bottom: 0;
}
input[type='radio']{
  width: 20px !important;
  height: 20px !important;
  margin: 5px;
  box-shadow: none;
  font-size: 2em;
  transform: translateY(.1em);
}
.fine-print {
  font-size: .7em;
}
</style>
